import {
  MockSportCategoryProps,
  categoryList,
  mockMoreSportsCategory,
  mockSportCategory,
} from 'api/mockSportCategory';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import baseball_image from 'assets/images/category/baseball.png';
import basketball_image from 'assets/images/category/basketball.png';
import boxing from 'assets/images/category/boxing.png';
import cricket from 'assets/images/category/cricket.png';
import esports from 'assets/images/category/esport.png';
import football_image from 'assets/images/category/football.png';
import golf from 'assets/images/category/golf.png';
import hockey_image from 'assets/images/category/hockey.png';
import mma from 'assets/images/category/mma.png';
import more_image from 'assets/images/category/more.png';
import soccer_image from 'assets/images/category/soccer.png';
import tennis from 'assets/images/category/tennis.png';
import { IMG_ALT } from 'consts/app';
import Typo from 'consts/typography';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { platformStates } from 'redux/platformSlice';
import { checkMoreSportActive } from 'utils/commonUtils';

interface TabCategoryProps {}

const images = [
  '',
  football_image,
  baseball_image,
  basketball_image,
  hockey_image,
  soccer_image,
  tennis,
  golf,
  mma,
  boxing,
  cricket,
  esports,
];

const categories = mockSportCategory.reduce((acc: MockSportCategoryProps[], category) => {
  if (!acc.some((item) => item.categoryId === category.categoryId)) {
    acc.push(category);
  }
  return acc;
}, []);

const moreSportCategories = mockMoreSportsCategory.reduce(
  (acc: MockSportCategoryProps[], category) => {
    if (!acc.some((item) => item.categoryId === category.categoryId)) {
      acc.push(category);
    }
    return acc;
  },
  [],
);

const getCategoryLabel = (value: string) => {
  switch (value) {
    case 'Football':
      return 'tabCategory.football';
    case 'Baseball':
      return 'tabCategory.baseball';
    case 'Basketball':
      return 'tabCategory.basketball';
    case 'Hockey':
      return 'tabCategory.hockey';
    case 'Soccer':
      return 'tabCategory.soccer';
    case 'Tennis':
      return 'tabCategory.tennis';
    case 'Golf':
      return 'tabCategory.golf';
    case 'MMA':
      return 'tabCategory.mma';
    case 'Boxing':
      return 'tabCategory.boxing';
    case 'Cricket':
      return 'tabCategory.cricket';
    case 'eSports':
      return 'tabCategory.esports';
    default:
      return 'tabCategory.football';
  }
};

const TabCategory: React.FunctionComponent<TabCategoryProps> = (props) => {
  const t = useAppTranslation();
  const { isPhone, isTablet } = useAppSelector(platformStates);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isShowMoreSports, setIsShowMoreSports] = useState<boolean>(false);
  const divMoreSportsRef = useRef<HTMLDivElement>(null);
  const currentCategory = searchParams.get('category');
  const handleDocumentClick = (event: MouseEvent) => {
    if (divMoreSportsRef.current && !divMoreSportsRef.current.contains(event.target as Node))
      setIsShowMoreSports(false);
    else setIsShowMoreSports((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const isMoreSportsActive: boolean = useMemo(() => {
    return checkMoreSportActive(currentCategory);
  }, [currentCategory]);

  const onClickTab = (index: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11) => {
    setSearchParams({ category: categoryList[index].category, tab: categoryList[index].tab });
  };

  return (
    <>
      <div className="group-tabs">
        {categories.map((category, index) => (
          <div
            key={`tab-category-${index}`}
            className={`tab-category tab-category${
              currentCategory === category.sportActivity.toLowerCase() ? '-active' : ''
            }`}
            onClick={() => onClickTab(category.categoryId as 1 | 2 | 3 | 4 | 5)}
          >
            <div className="image-category image-category-border">
              <img src={images[category.categoryId]} alt={IMG_ALT} />
            </div>
            <span
              className={`primary-text-color  ${isPhone ? Typo.p9 : isTablet ? Typo.p5 : Typo.p4}`}
            >
              {t(getCategoryLabel(category.sportActivity))}
            </span>
          </div>
        ))}
        <div
          className={`tab-category more-sports-button tab-category${
            isMoreSportsActive ? '-active' : ''
          }`}
          ref={divMoreSportsRef}
        >
          <div className="image-category image-category-border">
            <img
              src={
                isMoreSportsActive
                  ? images[
                      moreSportCategories.find(
                        (c) => c.sportActivity.toLowerCase() === currentCategory,
                      )?.categoryId || 0
                    ]
                  : more_image
              }
              alt={IMG_ALT}
              className={`${isMoreSportsActive ? '' : 'more-img'}`}
            />
          </div>
          <span
            className={`primary-text-color  ${isPhone ? Typo.p9 : isTablet ? Typo.p5 : Typo.p4}`}
          >
            {t('tabCategory.moreSports')}
          </span>
          <div className={`more-categories ${isShowMoreSports ? 'scale-100' : 'scale-0'}`}>
            {moreSportCategories.map((category, index) => (
              <div
                key={`more-categories-items-${index}`}
                className="more-categories__item"
                onClick={() => onClickTab(category.categoryId as 6 | 7 | 8 | 9 | 10 | 11)}
              >
                <div className="image-category">
                  <img src={images[category.categoryId]} alt={IMG_ALT} />
                </div>
                <span
                  className={`primary-text-color  ${
                    isPhone ? Typo.p9 : isTablet ? Typo.p5 : Typo.p4
                  }`}
                >
                  {t(getCategoryLabel(category.sportActivity))}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabCategory;
